import { collection, query, where, getDocs } from 'firebase/firestore';
import { db } from '../config/firebase';

/**
 * Generates a unique 8-character link ID in the format: ABC12345
 * (3 uppercase letters + 5 numbers)
 */
export const generateLinkId = async (): Promise<string> => {
  const maxAttempts = 10;
  let attempts = 0;

  while (attempts < maxAttempts) {
    const linkId = createRandomLinkId();
    const isUnique = await checkLinkIdUniqueness(linkId);

    if (isUnique) {
      return linkId;
    }

    attempts++;
  }

  throw new Error('Failed to generate unique link ID after multiple attempts');
};

/**
 * Creates a random link ID with format: ABC12345
 */
const createRandomLinkId = (): string => {
  const letters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
  const numbers = '0123456789';

  let linkId = '';

  // Generate 3 random uppercase letters
  for (let i = 0; i < 3; i++) {
    linkId += letters.charAt(Math.floor(Math.random() * letters.length));
  }

  // Generate 5 random numbers
  for (let i = 0; i < 5; i++) {
    linkId += numbers.charAt(Math.floor(Math.random() * numbers.length));
  }

  return linkId;
};

/**
 * Checks if a link ID already exists in Firestore
 */
const checkLinkIdUniqueness = async (linkId: string): Promise<boolean> => {
  try {
    const linksRef = collection(db, 'paymentLinks');
    const q = query(linksRef, where('linkId', '==', linkId));
    const querySnapshot = await getDocs(q);

    return querySnapshot.empty;
  } catch (error) {
    console.error('Error checking link ID uniqueness:', error);
    throw error;
  }
};
